/* VELORA theme JS — mobile menu, product gallery, quantity, AJAX add to cart. */
document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  /* Mobile menu toggle */
var toggle = document.querySelector('[data-mobile-menu-toggle]');
var menu = document.querySelector('[data-mobile-menu]');
if (toggle && menu) {
  menu.style.display = 'none';
  toggle.addEventListener('click', function () {
    var isHidden = menu.style.display === 'none';
    menu.style.display = isHidden ? 'block' : 'none';
    toggle.setAttribute('aria-label', isHidden ? 'Close menu' : 'Open menu');
  });
}

  /* Product gallery */
  var galleryMain = document.querySelector('[data-gallery-main]');
  var thumbs = document.querySelectorAll('[data-thumb]');
  if (galleryMain && thumbs.length) {
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        galleryMain.src = thumb.getAttribute('data-thumb');
        galleryMain.alt = thumb.getAttribute('alt') || galleryMain.alt;
        thumbs.forEach(function (t) {
          t.classList.remove('border-gold');
          t.classList.add('border-border');
        });
        thumb.classList.add('border-gold');
        thumb.classList.remove('border-border');
      });
    });
  }

  /* Quantity stepper */
  var minus = document.querySelector('[data-qty-minus]');
  var plus = document.querySelector('[data-qty-plus]');
  var qty = document.querySelector('[data-qty]');
  if (minus && plus && qty) {
    minus.addEventListener('click', function () {
      var v = parseInt(qty.value, 10) || 1;
      qty.value = Math.max(1, v - 1);
    });
    plus.addEventListener('click', function () {
      var v = parseInt(qty.value, 10) || 1;
      qty.value = v + 1;
    });
  }

  /* AJAX add to cart */
  var form = document.querySelector('[data-product-form]');
  var notice = document.querySelector('[data-form-notice]');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var body = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: body })
        .then(function (res) {
          if (!res.ok) throw new Error('cart error');
          return res.json();
        })
        .then(function () {
          return fetch('/cart.js', { method: 'GET' });
        })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var badge = document.querySelector('[data-cart-count]');
          if (badge) {
            if (cart.item_count > 0) {
              badge.textContent = cart.item_count;
              badge.classList.remove('hidden');
            } else {
              badge.classList.add('hidden');
            }
          }
          if (notice) notice.style.display = 'block';
        })
        .catch(function () {
          window.location.href = '/cart';
        });
    });
  }
});
